/**
 *
 * _input-date-range
 * change logs:
 * 2018/2/8 herbluo created
 */
import {isDate} from '../../../utils/util'

const MILLI_SECONDS_OF_A_DAY = 24 * 3600 * 1000
const NOW = new Date()
const YESTERDAY = new Date(NOW.getTime() - MILLI_SECONDS_OF_A_DAY)
// const ZERO_CLOCK_OF_LAST_MONTH = new Date(NOW.getFullYear(), NOW.getMonth() - 2, NOW.getDate())
const ZERO_CLOCK_OF_TODAY = new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate())
const ZERO_CLOCK_OF_YESTERDAY = new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate() - 1)
const zeroClockOf = date => {
  date = isDate(date) ? date : new Date(date)
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}
const theEndOf = date => {
  date = zeroClockOf(date)
  return new Date(date.getTime() + MILLI_SECONDS_OF_A_DAY - 1)
}

const OPTIONS = {
  DISABLED_DATE: {
    HENCEFORTH: (date) => {
      return date > new Date((NOW / 1000 + 86400) * 1000)
    },
    CATCHFORTH: (date) => {
      return date > new Date((NOW / 1000 - 86400) * 1000)
    },
  },
  SHORTCUT: {
    A_WEEK: {
      text: '最近一周',
      onClick (picker) {
        const end = new Date()
        const start = new Date(end.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    TWO_WEEKS: {
      text: '最近两周',
      onClick (picker) {
        const end = new Date()
        const start = new Date(end.getTime() - 3600 * 1000 * 24 * 14)
        picker.$emit('pick', [start, end])
      }
    },
    A_MONTH: {
      text: '最近一个月',
      onClick (picker) {
        const end = new Date()
        const start = new Date(end.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    THREE_MONTHS: {
      text: '最近三个月',
      onClick (picker) {
        const end = new Date()
        const start = new Date(end.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  }
}

const time = {
  now () {
    return new Date()
  },
  yesterday () {
    return YESTERDAY
  },
  zeroClockOfYesterday () {
    return ZERO_CLOCK_OF_YESTERDAY
  },
  todayRange () {
    return [
      ZERO_CLOCK_OF_TODAY,
      theEndOf(NOW)
    ]
  },
  yesterdayRange () {
    return [
      ZERO_CLOCK_OF_YESTERDAY,
      new Date(ZERO_CLOCK_OF_TODAY.getTime() - 1)
    ]
  },
  lastWeekRange () {
    return [
      zeroClockOf(NOW.getTime() - MILLI_SECONDS_OF_A_DAY * 7),
      new Date(ZERO_CLOCK_OF_TODAY.getTime() - 1)
    ]
  }
}

const inputDateHelper = {
  OPTIONS,
  time,
  zeroClockOf,
  theEndOf
}
export default inputDateHelper
export {
  inputDateHelper
}



// WEBPACK FOOTER //
// ./src/components/common/inputs/_input-date-helper.js